import { AxiosResponse } from 'axios'
import { PlusUser } from 'src/types/plusUser'

import axios from '../../axios'

export type AgencyAllowIpCreateRequestBody = {
  agencyCode: string
  ipAddress: string
}

export const createAgencyAllowIp = async (
  requestBody: AgencyAllowIpCreateRequestBody
): Promise<AxiosResponse> => {
  return axios.get(`/api/csrf-cookie`).then(() => {
    const response = axios
      .post<{ data: PlusUser }>(`/api/agency-ips`, requestBody)
      .catch((error) => {
        return error.response
      })

    return response
  })
}
